import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/admin',
    name: 'Home',
    component: Home
  },
  {
    path: "/:slug",
    name: "ProjectPage",
    component: () => import("../views/ProjectPage.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
